import { Table } from "@tanstack/react-table";
import { Input } from "@/components/ui/input";
import { DataTableViewOptions } from "@/components/admin/UserTable/data-table-view-options";
import { columns } from "./columns";
import { CreateSuperUserDialog } from "./CreateSuperUserDialog";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar({ table }: DataTableToolbarProps<typeof columns>) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row">
      <Input
        placeholder="Filter superuser by email..."
        value={(table.getColumn("email")?.getFilterValue() as string) ?? ""}
        onChange={(event) => table.getColumn("email")?.setFilterValue(event.target.value)}
      />
      <CreateSuperUserDialog />
      <DataTableViewOptions table={table} />
    </div>
  );
}
